import React, { useEffect, useRef, useState } from "react";
import Sidebar from "./sidebar/Sidebar";
import axios from "axios";
import api from "../api/axios";
import { toast } from "react-toastify";
import { LuDownload } from "react-icons/lu";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import logo from "./images/recipt _ Logo 1.png";
function AdminAllOrder() {
  //state
  const [sidebarToggle, setSidebarToggle] = useState(true);
  const [userdata, setUserdata] = useState([]);
  const [expendedRow, setExpendedRow] = useState(null);
  const [projectID, setProjectID] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [dragActive, setDragActive] = useState(false);
  const [popup, setPopup] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const today = new Date();
  const date = today.toLocaleDateString("en-GB");
  const [activeButton, setActiveButton] = useState("Address");
  const [inputdata, setInputdata] = useState("");
  const [recieptPopup, setRecieptPopup] = useState(false);
  const [selectedReciept, setSelectedReciept] = useState([]);
  const [customerID, setCustomerID] = useState(null)

  const allOrders = userdata.flatMap(user =>
    (user.orderDetails || []).map(order => ({
      ...order,
      firstName: user.first_name,
      lastName: user.last_name,
      companyName: user.organization,
      gst: user.gst_no,
      country: user.country,
      streetAddress: user.address,
      city: user.city,
      state: user.state,
      postcade: user.postcade,
      email: user.email,
      phone: user.mobile,
    }))
  );

 

  const fetchuserdata = async () => {
    try {
      const res = await api.get("/order");
      setUserdata(res.data);
    } catch (error) {
      console.error(error)
    }
  };

  useEffect(() => {
    fetchuserdata();
  }, []);

  const handlePDFupload = async (e) => {
    e.preventDefault();
    setPopup(false);
    try {
      const formData = new FormData();
      formData.append("selectedFile", selectedFile);
      formData.append("date", date);
      await api.put(`/update/${projectID}/${orderId}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      toast.success("Certificate Upload successfull..");
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const fdata = allOrders.filter((user) => {
      return (
        (user.firstName?.toString() || "").includes(inputdata) ||
        (user.lastName?.toString() || "").includes(inputdata) ||
        (user.email?.toString() || "").includes(inputdata) ||
        (user.phone?.toString() || "").includes(inputdata) ||
        (user.companyName?.toString() || "").includes(inputdata) ||
        (user.gst?.toString() || "").includes(inputdata) ||
        (user.orderdate?.toString() || "").includes(inputdata) ||
        (user.postcade?.toString() || "").includes(inputdata) ||
        (user.razorpayOrderId?.toString() || "").includes(inputdata) ||
        (user.razorpayPaymentId?.toString() || "").includes(inputdata) ||
        (user.state?.toString() || "").includes(inputdata) ||
        (user.streetAddress?.toString() || "").includes(inputdata)
      );
    });
    setFilteredPayments(fdata);
  };

  //pagination
  const recordPerPage = 20;
  const lastIndex = currentPage * recordPerPage;
  const firstIndex = lastIndex - recordPerPage;
  const records = allOrders.slice(firstIndex, lastIndex);
  const npage = Math.ceil(allOrders.length / recordPerPage);

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const nextPage = () => {
    if (currentPage < npage) setCurrentPage(currentPage + 1);
  };

  //sidebar toggle
  const toggleClick = () => {
    setSidebarToggle(!sidebarToggle);
  };

  const handleChange = (e) => {
    setInputdata(e.target.value);
  };

  const handleRefresh = () => {
    setInputdata("");
    setFilteredPayments([]);
    setCurrentPage(1)
  };

  const handleExpendRow = (id) => {
    setExpendedRow((prev) => (prev === id ? null : id));
  };

  const handlePopup = (projectid, userid, customerid) => {
    setOrderId(userid);
    setProjectID(projectid);
    setCustomerID(customerid);
    setPopup(true);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    const file = e.dataTransfer.files[0];
    setSelectedFile(file);
  };

  // console.log("allOrders",allOrders)
  const handleRecipt = (id) => {
    const user = allOrders.find((user) => user._id === id);

    setSelectedReciept({
      ...user,
      firstName: user.firstName,
      lastName: user.lastName,
      gst_no: user.gst,
      email: user.email,
      mobile: user.phone
    })
    setRecieptPopup(true);
  }

  const closePopup = () => {
    setRecieptPopup(false);
  };

  const printRef = useRef(null);

  const handleDownloadPDF = async () => {
    if (!printRef.current) return;
    try {
      const style = document.createElement("style");
      style.innerHTML = ``;
      document.head.appendChild(style);
      // Generate canvas
      const canvas = await html2canvas(printRef.current, {
        scale: 4,
        useCORS: true,
        backgroundColor: "#ffffff",
        onclone: (documentClone) => {
          const clonedElement = documentClone.getElementById("printRefId");
          if (clonedElement) {
            clonedElement.style.fontFamily = "Arial, sans-serif";
            clonedElement.style.color = "black";
            clonedElement.style.border = "1px solid #000";
          }
        },
      });

      // Convert canvas to image
      const dataURL = canvas.toDataURL("image/png");

      // Create PDF
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(dataURL, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("Receipt.pdf");
      // Remove dynamically added styles after PDF generation
      document.head.removeChild(style);

      setRecieptPopup(false);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  const subtotalprice = selectedReciept.usercart?.reduce(
    (acc, item) => acc + (Number(item.price) * Number(item.count) || 0),
    0
  );

  return (
    <>
      {/* header section-1 */}
      <div className="font-[Poppins] flex ">
        {sidebarToggle ? <div className="w-[320px] nirav"></div> : null}
        <Sidebar toggleClick={toggleClick} sidebarToggle={sidebarToggle} />
        <div className="w-[100%] ">
          <div className=" 2xl:w-[90%] w-[95%] m-auto 2xl:mt-16 mt-10  xl:p-2 lg:p-10  p-2">
            <div className="sm:flex sm:justify-between sm:items-center">
              <h1 className="font-medium 2xl:text-2xl text-xl">
                Hello Admin 👋🏼
              </h1>
            </div>
            {popup && (
              <div className="fixed inset-0 top-0 left-0 w-screen h-screen z-[9999]  flex items-center justify-center bg-black bg-opacity-50">
                <form
                  onSubmit={handlePDFupload}
                  className="bg-white border rounded-[24px]  shadow-lg border-[#C65B1D] w-[556px]   p-10 max-w-6xl"
                >
                  <div className="text-end">
                    <i
                      onClick={() => setPopup(false)}
                      className="fa-solid fa-xmark text-lg cursor-pointer"
                    ></i>
                  </div>
                  <div className="text-center">
                    <h3 className="text-[#C65B1D] text-3xl font-medium">
                      Upload Doc
                    </h3>
                  </div>
                  <div
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    className={`border-2 border-dashed border-[#C65B1D] flex justify-center flex-col gap-4 items-center p-10 rounded-[20px] mt-10 ${dragActive ? "bg-orange-50" : ""
                      } cursor-pointer`}
                  >
                    <input
                      type="file"
                      accept=".png,.jpg,.jpeg,.pdf"
                      onChange={handleFileChange}
                      className="hidden"
                      id="fileInput"
                    />
                    <label
                      htmlFor="fileInput"
                      className="text-center cursor-pointer"
                    >
                      <i className="fa-solid fa-arrow-up-from-bracket text-[#686868] text-xl"></i>
                      <h3 className="text-[22px] mt-2">
                        Drag & drop or Browse
                      </h3>
                      <p className="text-[#B5B7C0] text-sm">
                        (Only PNG, JPG, PDF files allowed.)
                      </p>
                    </label>
                    {selectedFile && (
                      <p className="text-green-700 mt-4 text-sm">
                        Selected: {selectedFile.name}
                      </p>
                    )}
                  </div>
                  <div>
                    <button
                      type="submit"
                      className="bg-[#C65B1D] w-full mt-10 p-2 rounded-lg text-white"
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            )}

            {recieptPopup && (
              <>
                <div
                  onClick={closePopup}
                  className="fixed inset-0 flex flex-col top-0 left-0 w-screen h-screen z-[9999] items-center justify-center bg-black bg-opacity-50"
                >
                  <button
                    className="bg-[#C65B1D] px-4 py-1 rounded-md text-white mb-2"
                    onClick={handleDownloadPDF}
                  >
                    Downolad PDF
                  </button>
                  <div
                    ref={printRef}
                    className="bg-white border flex flex-col gap-10  shadow-lg  w-[556px] h-[800px]  py-16 px-6 max-w-6xl"
                  >
                    <div className="flex justify-between items-start">
                      <div>
                        <h2 className="text-sm font-semibold">
                          {selectedReciept.firstName} {selectedReciept.lastName}
                        </h2>
                        <p className="text-xs text-[#646464]">
                          GSTIN : <span>{selectedReciept.gst_no}</span>{" "}
                        </p>
                      </div>
                      <div>
                        <img className="w-[100px] h-[20px]" src={logo} alt="" />
                      </div>
                    </div>

                    <div className="text-xs">
                      <p className="text-[#505050]">
                        <span className="text-sm font-medium">
                          Payment Receipt :
                        </span>
                        Transaction Reference :{" "}
                        <span className="text-[#646464]">
                          {selectedReciept.razorpayPaymentId}
                        </span>{" "}
                      </p>
                      <p className="text-[#646464]">
                        This is a payment receipt for your transaction on
                        Project RenewCred-1
                      </p>
                    </div>

                    <div>
                      <h2 className="text-sm text-[#646464]">
                        AMOUNT PAID:
                        <span className="font-semibold text-sm">
                          ₹{" "}
                          {selectedReciept.finalPrice}
                        </span>
                      </h2>
                    </div>

                    <div className="grid grid-cols-2 text-[#646464] text-xs">
                      <div className="leading-5">
                        <p>ISSUED To</p>
                        <p>Email: {selectedReciept.email}</p>
                        <p>Mo: {selectedReciept.mobile}</p>
                      </div>
                      <div>
                        <p>PAID ON</p>
                        <p>{selectedReciept.orderdate}</p>
                      </div>
                    </div>
                    <div className="">
                      <table className="min-w-[100%] table-auto  shadow-sm border border-separate border-spacing-0">
                        <thead className="bg-[#f0f0f0] font-medium">
                          <tr>
                            <th className="py-1   text-[#646464] whitespace-nowrap   text-xs text-center border-b border-gray-300 ">
                              DESCRIPTION
                            </th>
                            <th className=" py-1 w-[40px] text-[#646464] whitespace-nowrap  text-xs text-center border-b border-gray-300">
                              UNIT PRICE
                            </th>
                            <th className="py-1 w-[20px] text-[#646464] whitespace-nowrap   text-xs  text-center border-b border-gray-300">
                              QTY
                            </th>

                            <th className="py-1 w-[40px] text-[#646464] whitespace-nowrap  text-xs  text-center border-b border-gray-300">
                              AMOUNT
                            </th>
                          </tr>
                        </thead>
                        <tbody className="text-xs font-normal">
                          {selectedReciept.usercart.map((product, index) => {
                            return (
                              <tr key={index}>
                                <td className="py-1 border  text-[#5A607F] border-[#E4E7EC] text-center">
                                  {product.projectname}
                                </td>
                                <td className="py-1 border  text-[#5A607F] border-[#E4E7EC] text-center">
                                  {product.price}
                                </td>
                                <td className="py-1 border  text-[#5A607F] border-[#E4E7EC] text-center">
                                  {product.count}
                                </td>
                                <td className="py-1 border  text-[#5A607F] border-[#E4E7EC] text-center">
                                  {product.price * product.count}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                      <div className="flex justify-end space-y-4 text-xs mb-10">
                        {/* Billing Summary Section */}
                        <div className="w-36 p-2 space-y-1">
                          <div className="flex justify-between items-center">
                            <p className="font-medium">Total:</p>
                            <p className="font-normal">
                              {subtotalprice}
                            </p>
                          </div>
                          <div className="flex justify-between items-center">
                            <p className="font-medium text-[#00AC4F]">
                              Amount Paid:
                            </p>
                            <p className="font-normal text-[#00AC4F]">
                              ₹{" "}
                              {selectedReciept.finalPrice}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="border mt-5  2xl:rounded-[30px] rounded-[20px] px-10 py-8  bg-white shadow-sm">
              <div className="mx-2 my-2 flex flex-wrap justify-between items-center">
                <div className="mb-3">
                  <h1 className="font-semibold 2xl:text-2xl text-xl">
                    All Orders
                  </h1>
                </div>
                {/* filter table data form */}
                <div className="flex items-center flex-wrap gap-1">
                  <form
                    className="filterinput"
                    action=""
                    onSubmit={handleSubmit}
                  >
                    <input
                      onChange={handleChange}
                      type="text"
                      name="inputdata"
                      value={inputdata}
                      className="bg-[#F9FBFF]  sm:px-5 max-sm:w-[68%] pl-3 2xl:py-2 py-[0.40rem] border border-gray-300  outline-none focus:ring-2 focus:ring-[#C65B1D] rounded-lg text-xs max-md:my-1"
                      placeholder="Search"
                    />
                    <button
                      type="submit"
                      className="mr-1 ml-3 cursor-pointer bg-[#C65B1D]  hover:shadow-md button text-white py-[0.4rem] 2xl:text-sm text-xs rounded-lg 2xl:px-3 px-2"
                    >
                      Search
                    </button>
                  </form>
                  {/* filter table data by ticketname */}
                  <div className="flex justify-between items-center flex-wrap">
                    <i
                      onClick={handleRefresh}
                      className="fa-solid fa-arrows-rotate ml-2 cursor-pointer border border-gray-300 px-2 2xl:py-[0.45rem] py-[0.40rem] rounded-md bg-[#F9FBFF]"
                    ></i>
                  </div>
                </div>
              </div>
              <div className="mt-6 relative overflow-x-auto  overflow-y-hidden">
                <table className="w-full border-collapse border-spacing-0">
                  <thead>
                    <tr className="text-[#b5b7c0] m-12 font-medium">
                      <th className="whitespace-nowrap text-center">Sr no</th>
                      <th className="whitespace-nowrap">Order ID</th>
                      <th className="whitespace-nowrap">Order Date</th>
                      <th className="whitespace-nowrap">Customer Name</th>
                      <th className="whitespace-nowrap">Phone No</th>
                      <th className="whitespace-nowrap">Email</th>
                      <th className="whitespace-nowrap">Transaction ID</th>
                      <th className="text-center">Credits (Tones)</th>
                      <th className="whitespace-nowrap text-center">Total Amount</th>
                      <th className="whitespace-nowrap text-center">Receipt</th>
                      <th className="whitespace-nowrap"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {(filteredPayments.length > 0
                      ? filteredPayments
                      : records
                    ).map((tdata, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td className="text-center">{firstIndex + index + 1}</td>
                            <td>{tdata.razorpayOrderId}</td>
                            <td>{tdata.orderdate}</td>
                            <td className="whitespace-nowrap">
                              {tdata.firstName} {tdata.lastName}
                            </td>
                            <td>{tdata.phone}</td>
                            <td>{tdata.email}</td>
                            <td>{tdata.razorpayPaymentId}</td>
                            <td className="text-center">{tdata.credits}</td>
                            <td className="text-center"> ₹ {tdata.finalPrice}</td>
                            <td className="text-center">
                              <i onClick={() => handleRecipt(tdata._id)
                              } className="fa-solid fa-download cursor-pointer"></i>
                            </td>
                            <td>
                              {" "}
                              <i
                                onClick={() => handleExpendRow(index)}
                                className={`fa-solid ${expendedRow === index ? "fa-minus" : "fa-plus"
                                  }  cursor-pointer`}
                              ></i>
                            </td>
                          </tr>
                          {expendedRow === index && (
                            <>
                              <tr>
                                <td colSpan="12">
                                  <div className="flex gap-6 mt-2">
                                    <button
                                      onClick={() => setActiveButton("Address")}
                                      className={`${activeButton === "Address"
                                        ? " text-[#C65B1D] e"
                                        : "text-[#4D4D4D]  "
                                        } font-medium text-sm leading-5 cursor-pointer `}
                                    >
                                      Address
                                    </button>

                                    <button
                                      onClick={() =>
                                        setActiveButton("Projects")
                                      }
                                      className={`${activeButton === "Projects"
                                        ? " text-[#C65B1D] e "
                                        : "text-[#4D4D4D]  "
                                        } font-medium text-sm leading-5 cursor-pointer `}
                                    >
                                      Projects
                                    </button>
                                  </div>
                                  {activeButton === "Address" && (
                                    <table className="min-w-[100%] my-2 table-auto border border-[#E5E5E5] border-separate border-spacing-0 rounded-t-lg shadow-sm">
                                      <thead className="bg-[#FCFCFC] rounded-t-lg">
                                        <tr className="">
                                          <th
                                            className={`whitespace-nowrap p-2 pl-4 rounded-tl-lg   border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8 border-[#E5E5E5]">
                                              Company Name
                                            </div>
                                          </th>
                                          <th
                                            className={`whitespace-nowrap p-2 pl-0 border-b  border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              GST
                                            </div>
                                          </th>
                                          <th
                                            className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              Address
                                            </div>
                                          </th>
                                          <th
                                            className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              State
                                            </div>
                                          </th>
                                          <th
                                            className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              City
                                            </div>
                                          </th>
                                          <th
                                            className={`whitespace-nowrap p-2 pl-0 rounded-tr-lg  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="  border-[#E5E5E5]">
                                              Pincode
                                            </div>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td className="pl-4">
                                            {tdata.companyName}
                                          </td>
                                          <td className="pl-0">{tdata.gst}</td>
                                          <td className="pl-0">
                                            {tdata.streetAddress}
                                          </td>
                                          <td className="pl-0">
                                            {tdata.state}
                                          </td>
                                          <td className="pl-0">{tdata.city}</td>
                                          <td className="pl-0">
                                            {tdata.postcade}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  )}
                                  {activeButton === "Projects" && (
                                    <table className="min-w-[100%] my-2 table-auto border border-[#E5E5E5] border-separate border-spacing-0 rounded-t-lg shadow-sm">
                                      <thead className="bg-[#FCFCFC] rounded-t-lg">
                                        <tr className="">
                                          <th
                                            className={`whitespace-nowrap p-2 pl-4 rounded-tl-lg   border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8 border-[#E5E5E5]">
                                              Project ID
                                            </div>
                                          </th>
                                          <th
                                            className={`whitespace-nowrap p-2 pl-0 border-b  border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              Project Name
                                            </div>
                                          </th>
                                          <th
                                            className={`whitespace-nowrap p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              Methodology
                                            </div>
                                          </th>
                                          <th
                                            className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              Credits (Tones)
                                            </div>
                                          </th>
                                          <th
                                            className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              Unit Price
                                            </div>
                                          </th>
                                          <th
                                            className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              Amount
                                            </div>
                                          </th>
                                          <th
                                            className={`whitespace-nowrap p-2 pl-0 rounded-tr-lg  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-center `}
                                          >
                                            <div className="  border-[#E5E5E5]">
                                              Certificate
                                            </div>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {tdata.usercart.map((user, index) => {
                                          const filename = user.certificateURL
                                            ?.split("-")
                                            .pop();
                                          return (
                                            <tr key={index}>
                                              <td className="pl-4">
                                                {user.projectid}
                                              </td>
                                              <td className="pl-0">
                                                {user.projectname}
                                              </td>
                                              <td>{user.methodology}</td>
                                              <td className="pl-0">
                                                {user.count}
                                              </td>
                                              <td className="pl-0">
                                                ₹ {user.price}
                                              </td>
                                              <td className="pl-0">
                                                ₹ {user.price * user.count}
                                              </td>
                                              <td className="pl-0 text-center">
                                                {filename ? (
                                                  <button
                                                    onClick={() =>
                                                      user.certificateURL &&
                                                      window.open(
                                                        user.certificateURL,
                                                        "_blank"
                                                      )
                                                    }
                                                    className="text-[#0167FF] text-xl"
                                                  >
                                                    <LuDownload />
                                                  </button>
                                                ) : (
                                                  <p className="text-[#C65B1D]">
                                                    Pending
                                                  </p>
                                                  // <button
                                                  //   onClick={() => {
                                                  //     handlePopup(
                                                  //       user._id,
                                                  //       tdata._id,
                                                  //       userdata._id
                                                  //     );
                                                  //   }}
                                                  //   className="bg-[#F9EFE8] text-[#C65B1D] rounded-[4px] cursor-pointer font-medium px-2 py-[0.15rem]"
                                                  // >
                                                  //   Upload
                                                  // </button>
                                                )}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  )}
                                </td>
                              </tr>
                            </>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              {/* pagination */}
              <div className="flex justify-between items-center mt-4">
                <button
                  onClick={prevPage}
                  disabled={currentPage === 1}
                  className={`px-4 py-2 bg-[#C65B1D] hover:bg-[#C65B1D] text-white rounded-lg mr-2 transition duration-200 ease-in-out ${currentPage === 1
                    ? "opacity-50 cursor-not-allowed"
                    : "cursor-pointer"
                    }`}
                  aria-label="Previous Page"
                >
                  Prev
                </button>

                <button
                  onClick={nextPage}
                  disabled={currentPage === npage}
                  className={`px-4 py-2 bg-[#C65B1D] hover:bg-[#C65B1D] text-white rounded-lg ml-2 transition duration-200 ease-in-out ${currentPage === npage
                    ? "opacity-50 cursor-not-allowed"
                    : "cursor-pointer"
                    }`}
                  aria-label="Next Page"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminAllOrder;
